import { createEnvUrl } from "@app/routes";
import { ButtonLink } from "@app/ui/shared/button";

export interface NoEnvironmentsProps {
  organizationName: string;
  canCreateEnvironment: boolean;
}

export const NoEnvironments = ({
  organizationName,
  canCreateEnvironment,
}: NoEnvironmentsProps) => {
  return (
    <div className="mx-auto max-w-3xl rounded-xl border border-gray-200 bg-white p-8 text-center shadow-sm">
      <h1 className="text-2xl font-semibold text-gray-900">
        No Environments to Evaluate
      </h1>
      <p className="mt-4 text-gray-700">
        The Security &amp; Compliance dashboard evaluates the security posture
        of your environments, but we can&apos;t find any environments to assess.
        To view your security controls and compliance status, you&apos;ll need
        to create at least one environment first.
      </p>
      <div className="mt-6 rounded-lg bg-gray-100 p-4 text-sm text-gray-700">
        <strong className="font-semibold">What are environments?</strong>
        <p className="mt-2">
          Environments are isolated spaces where you deploy and run your
          applications and databases on Aptible&apos;s platform.
        </p>
        <a
          href="https://www.aptible.com/docs/core-concepts/architecture/environments"
          target="_blank"
          rel="noreferrer"
          className="mt-2 inline-block text-sm font-medium text-blue-600 hover:underline"
        >
          Learn more
        </a>
      </div>

      <div className="mt-8">
        {canCreateEnvironment ? (
          <ButtonLink to={createEnvUrl()} variant="primary">
            Create Your First Environment
          </ButtonLink>
        ) : (
          <p className="text-sm text-gray-700">
            You don&apos;t have permission to create environments. Contact an
            account owner in <strong>{organizationName}</strong> to create an
            environment, or ask them to grant you the necessary permissions.
          </p>
        )}
      </div>
    </div>
  );
};
